export const EDIT_TRANSACTION_REQUEST = 'EDIT_TRANSACTION_REQUEST';
export const EDIT_TRANSACTION_SUCCESS = 'EDIT_TRANSACTION_SUCCESS';
export const EDIT_TRANSACTION_FAILURE = 'EDIT_TRANSACTION_FAILURE';
